import { SupportInfo } from "./SupportInfo";
export default SupportInfo;



// WEBPACK FOOTER //
// ./src/components/atomic/molecules/SupportInfo/index.js